var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNotificationAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.86719 0C9.53125 0 10.1172 0.585938 10.1172 1.25V2.03125C12.9688 2.57812 15.1172 5.11719 15.1172 8.125V8.86719C15.1172 10.7031 15.7812 12.5 16.9922 13.8672L17.2656 14.1797C17.6172 14.5703 17.6953 15.0781 17.5 15.5469C17.3047 15.9766 16.8359 16.25 16.3672 16.25H1.36719C0.859375 16.25 0.390625 15.9766 0.195312 15.5469C0 15.0781 0.078125 14.5703 0.429688 14.1797L0.703125 13.8672C1.91406 12.5 2.61719 10.7031 2.61719 8.86719V8.125C2.61719 5.11719 4.76562 2.57812 7.61719 2.03125V1.25C7.61719 0.585938 8.16406 0 8.86719 0ZM10.625 19.2969C10.1562 19.7656 9.53125 20 8.86719 20C8.20312 20 7.53906 19.7656 7.07031 19.2969C6.60156 18.8281 6.36719 18.1641 6.36719 17.5H8.86719H11.3672C11.3672 18.1641 11.0938 18.8281 10.625 19.2969Z",
    fill: "#494968"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotificationAlert);
export default __webpack_public_path__ + "static/media/icon_notification_alert.dfff288756091a2de5e035c4f7112502.svg";
export { ForwardRef as ReactComponent };